import React from 'react';
import { WidgetProps } from '@rjsf/utils';
import './styles/CustomRangeStyles.css';

const CustomRangeWidget: React.FC<WidgetProps> = ({
    schema,
    value,
    label,
    required,
    onChange,
    options,
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value);
        // Update the CSS variable for the selected value
        e.target.style.setProperty('--value', `${(e.target.valueAsNumber - Number(e.target.min)) / (Number(e.target.max) - Number(e.target.min)) * 100}%`);
    };

    const min = typeof schema.minimum === 'number' ? schema.minimum : 0;
    const max = typeof schema.maximum === 'number' ? schema.maximum : 100;
    const step = typeof options.step === 'number' ? options.step : 1;

    return (
        <div className="flex flex-col">
            <div>
                <span className="mt-1 text-center text-gray-700 dark:text-gray-200 font-medium">Selected: {value}</span>
                <div className="flex flex-row items-center">
                    <span className='mr-2 text-gray-700 dark:text-gray-200 font-medium'>{min}</span>
                    <input
                        type="range"
                        value={value || 0}
                        min={min}
                        max={max}
                        step={step}
                        onChange={handleChange}
                        className="mt-2 w-full h-2 rounded-lg cursor-pointer range-thumb"
                        style={{ '--value': `${(value - min) / (max - min) * 100}%` } as React.CSSProperties}
                    />
                    <span className='ml-2 text-gray-700 dark:text-gray-200 font-medium'>{max}</span>
                </div>
            </div>
        </div>
    );
};

export default CustomRangeWidget;